export default "__VITE_ASSET__ee09cbb1__"